export class functionpermission {
    homehealthagencycreate: boolean = true;
    homehealthagencyupdate: boolean = true;
    homehealthagencydelete: boolean = true;
}
export class Homehealthagency {
    id: string;
    hhaName: string;
    address: string;
    apt: string;
    city: string;
    state: string;
    zipCode: string;
    phoneNumber: string;
    email: string;
    fax: string;
    statusLId: string | null;
    statusLovName: string |null;
}


export class getHomehealthagency {
currentpageno: number = 1;
  pageitem: number = 10;
  searchText: string;
  orderColumn: string = "hhaName";
  orderType: string = "asc";
  type: string = "string";
  field: string = "hhaName";
  operator: string = "startswith";
  value: string = "";
  matchCase: boolean = false;
  statusLid: string="00000000-0000-0000-0000-000000000000";
}